export interface DivinationRecord {
  id: string;
  question: string;
  hexagramName: string;
  hexagramNumber: number;
  upperTrigram: string;
  lowerTrigram: string;
  interpretation: string;
  rounds: Array<{
    round: number;
    total: number;
    results: string[];
  }>;
  createdAt: number;
}

const STORAGE_KEY = 'iching_divination_records';

export function saveRecord(record: Omit<DivinationRecord, 'id' | 'createdAt'>): DivinationRecord {
  const newRecord: DivinationRecord = {
    ...record,
    id: `${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
    createdAt: Date.now(),
  };

  const existing = getRecords();
  const updated = [newRecord, ...existing].slice(0, 50); // 最多保存50条
  localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  return newRecord;
}

export function getRecords(): DivinationRecord[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function deleteRecord(id: string): void {
  const existing = getRecords();
  const updated = existing.filter((r) => r.id !== id);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
}

export function updateInterpretation(id: string, interpretation: string): void {
  const existing = getRecords();
  const updated = existing.map((r) => (r.id === id ? { ...r, interpretation } : r));
  localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
}

export function clearAllRecords(): void {
  localStorage.removeItem(STORAGE_KEY);
}

export function formatRecordDate(timestamp: number): string {
  const d = new Date(timestamp);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  const hour = String(d.getHours()).padStart(2, '0');
  const minute = String(d.getMinutes()).padStart(2, '0');
  return `${year}-${month}-${day} ${hour}:${minute}`;
}